import { Collapse } from "@itank/playground/utils/bootstrap";
function initPromo(){
    let btn = document.querySelector('.promo-code-button');
    let btn2 = document.querySelector('.cancel-promo');
    let promo = document.getElementById('promo-code');
    if(!promo || !btn) return ;

    if(btn2) btn2.addEventListener('click',event=>{
        event.preventDefault();
        Collapse.collapse(promo);
        return true;
    });

    btn.querySelector('a').addEventListener('click',(event)=>{
         let s= promo.style.display;
         event.preventDefault();
         Collapse.collapse(promo);
         return true;

         promo.style.display=(s=='block')?'none':'block';
         if(s!='block   '){
            promo.classList.add('in');
         }else 
            promo.classList.remove('in');

         return true;
    });
}
window.addEventListener('load',function(){
    initPromo();
});